import { Component, Input } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'ups-label',
    template: `<label class="slds-col">{{ to.label }}</label>`,
    styleUrls: ['./label.type.component.scss'],
    standalone: false
})
export class LabelTypeComponent extends FieldType {
  @Input() set defaults(opt: FormlyFieldConfig) {
    this.field = opt;
  }
}
